/**
 * @Description 商圈详情头部部分
 */
import { FC, useState, useEffect, useMemo, useRef, useContext } from 'react';
import { useMethods } from '@lhb/hook';
import { downloadFile } from '@lhb/func';
import { getCookie } from '@lhb/cache';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
// import { bigdataBtn } from '@/common/utils/bigdata';
import { exportModelClusterPDFAsync } from '@/common/api/siteselectionmap';
import { ARE_AREPORT_CONTAINER_CLASS, AreaReportModule, ChildreClass } from '@/views/pdf/pages/areareport/ts-config';
// import cs from 'classnames';
import styles from './index.module.less';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
// import IconFont from '@/common/components/IconFont';
import LabelRow from '../LabelRow';
import DataInfoModal from './DataInfoModal';
import Entrance from '@/views/iterate/pages/siteselectionmapb/components/CreateFavorite/Entrance';
import { useSelector } from 'react-redux';
import { useBigdataFn } from '@/common/utils/bigdata';
import { getSiteModelList } from '@/common/api/networkplan';
import UserInfoContext from '@/layout/context';
import { globalExpansionTaskAlias, globalOpeningAreaAlias } from '@/common/utils/ways';
import GatherClientDrawer from '../GatherClientDrawer';
import Share from './Share';
import CreateTask from './CreateTask';
import EditFormModal from './EditFormModal';

const { Text } = Typography;

const Top: FC<any> = ({
  id,
  detail,
  rank,
  showCollect,
  onLabelChanged, // 标签编辑后回调
  labelOptionsChanged,
  pdfDataStatus, // pdf状态
  getPDFStatus, // 轮训接口,
  onRefreshGather, // 刷新
  createTaskPermission, // 创建拓店任务按钮权限
  disabledCreateTask, // 拓店任务按钮禁用权限
  historyTaskPermission, // 拓店任务历史按钮权限
  setHistoryVisible, // 拓店任务历史
  setShowCreateDrawer, // 创建拓店任务抽屉
  overViewData,
  gatherClientPoint, // 集客点按钮展示权限与状态
  getDetail,
  setEditModalData,
  editModalData,
}) => {
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const modelConfigId = useSelector((state: any) => state.iterate.modelConfigId); // 存放选址地图页面的当前模型
  const { isFavourate } = detail;
  const intervalRef: any = useRef();
  const [openDataInfo, setOpenDataInfo] = useState(false); // 打开数据说明弹窗
  const [collectStatus, setCollectStatus] = useState(isFavourate);
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const [progress, setProgress] = useState<number>(0);
  const [gatherClientPointDrawer, setGatherClientPointDrawer] = useState<any>({
    visible: false,
    value: {}
  });// 集客点抽屉
  const { tenantInfo, id: userId } = useContext(UserInfoContext); // 租户信息
  const { globalAliasItemVOs } = tenantInfo;
  const expansionTaskAlias = globalExpansionTaskAlias(globalAliasItemVOs);
  const areaAlias = globalOpeningAreaAlias(globalAliasItemVOs);

  const exportPermission = useMemo(() => { // 导出报告按钮权限
    return detail?.permissions?.find((item) => item.event === 'siteselectionmapb:export');
  }, [detail?.permissions]);
  const showDownloadBtn = useMemo(() => { // 显示下载报告按钮
    const { exportStatus, name, url } = pdfDataStatus || {};
    return exportStatus === 2 && name && url;
  }, [pdfDataStatus]);
  const editPermission = useMemo(() => { // 编辑权限
    return detail?.permissions?.find((item) => item.event === 'modelCluster:edit');
  }, [detail?.permissions]);

  useEffect(() => {
    const { exportStatus } = pdfDataStatus || {};
    if (exportStatus === 3) {
      setIsExporting(true);
      if (intervalRef.current) return; // 如果还未创建定时器说明是第一次进来
      setProgress(99);
    } else {
      setIsExporting(false);
      setProgress(0);
      if (!intervalRef.current) return;
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, [pdfDataStatus]);

  useEffect(() => {
    setCollectStatus(!!detail?.isFavourate);
  }, [detail]);

  const methods = useMethods({
    jumpToTarget: () => {
      const { servicePlaceId } = detail;
      if (!servicePlaceId) {
        V2Message.warning('数据异常，未获取到资源id');
        return;
      }
      // bigdataBtn('abcfb807-a1f8-4aaf-9db9-6ab09f9546b5', '选址地图', '商圈详情-案例及订单', '点击商圈详情-案例及订单');
      window.open(`${process.env.LINHUIBA_ADMIN}lhb-micro-pms/placeMng/detail?tenantPlaceId=${servicePlaceId}`);
    // https://lhb.lanhanba.com/#/lhb-micro-pms/placeMng/detail?tenantPlaceId=40474
    },
    exportPDF: async () => {
      // const token = getCookie('flow_token');
      const tenantId = getCookie('tenantId');
      const employeeId = getCookie('employeeId');
      setIsExporting(true);
      intervalRef.current = setInterval(() => {
        if (progress === 99) {
          intervalRef.current && clearInterval(intervalRef.current);
          return;
        }
        setProgress((state) => {
          if (state < 95) return state + 5;
          return 99;
        });
      }, 600);
      let targetModelConfigId = modelConfigId;
      if (!targetModelConfigId || +targetModelConfigId <= 0) {
        const data = await getSiteModelList();
        targetModelConfigId = data[0]?.id || 0;
      }
      // 兜底，防止机会点所属商圈组件在引用该详情时，没有配置选址地图模型
      if (!targetModelConfigId) {
        V2Message.warning(`请先配置选址地图模型！`);
        return;
      }

      const params = {
      // name: detail.areaName || '商圈报告',
        name: `${detail.areaName || '商圈报告'}.pdf`,
        type: 1, // 导出类型：1:商圈 2:机会点
        id: detail.id,
        nodeData: {
          name: `${detail.areaName || '商圈报告'}.pdf`,
          options: [
            { // 定制化模块，并合并至最终的pdf里
              url: [
                `${process.env.CONSOLE_PC_URL}/pdf/areareport?id=${detail.id}&moduleName=${AreaReportModule.MODULE_1}&tenantId=${tenantId}&modelConfigId=${targetModelConfigId}&employeeId=${employeeId}`,
                `${process.env.CONSOLE_PC_URL}/pdf/areareport?id=${detail.id}&moduleName=${AreaReportModule.MODULE_2}&tenantId=${tenantId}&modelConfigId=${targetModelConfigId}&employeeId=${employeeId}`,
                `${process.env.CONSOLE_PC_URL}/pdf/areareport?id=${detail.id}&moduleName=${AreaReportModule.MODULE_3}&tenantId=${tenantId}&modelConfigId=${targetModelConfigId}&employeeId=${employeeId}`,
              ],
              containerClass: ARE_AREPORT_CONTAINER_CLASS,
              childClass: ChildreClass,
              // delay: 1500, // 延迟截图
            }
          ],
          needPageTable: true,
        },
      };
      bigdataFn('a96c7a51-a3d9-4b36-bd17-fc89dd215cb9', '详情-导出报告', '点击了详情-导出报告', { op_block: '开店区域-详情页', op_event: `${detail.cityName}-${detail.areaName}`, });
      // 接口异步下载
      await exportModelClusterPDFAsync(params).finally(() => {
      // setIsExporting(false);
      // setShowHintModal(true);
        V2Message.success('报告正在生成中，请稍后查看');
        // 轮训状态
        getPDFStatus && getPDFStatus();
      });
    },
    handleDownload: () => {
      bigdataFn('c8eac377-19d3-4ff6-8ebd-fd668efcfbd0', '详情-查看报告', '点击了详情-查看报告', { op_block: '开店区域-详情页', op_event: `${detail.cityName}-${detail.areaName}`, });
      const { name, url } = pdfDataStatus;
      downloadFile({
        name,
        url: `https://staticres.linhuiba.com//libs/preview-pdf/web/viewer.html?file=${encodeURIComponent(url)}&fixname=` + encodeURIComponent(`${name}`)
      });
    }
  });

  return (
    <div className={styles.topCon}>
      <div className={styles.titleRow}>
        <Text
          style={{ width: 580 }}
          ellipsis={{ tooltip: detail.areaName }}>
          <span className='fs-20 c-222 bold'>
            {rank ? `${rank}.` : ''}
            {detail.areaName}
          </span>
        </Text>
        <div className={styles.flexCon}>
          <div className={styles.targetOffset} onClick={() => {
            setOpenDataInfo(true);
            bigdataFn('ed2fc180-68e0-4912-80cf-1bb5cd3e7550', '详情-数据说明', '点击了详情-数据说明', { op_block: '开店区域-详情页', op_event: `${detail?.cityName}-${detail.areaName}`, });
          }}>
            <div className='fs-12 c-666 rt'>
              <span className='pr-4'>数据说明</span>
              <QuestionCircleOutlined />
            </div>
          </div>
          {
            showCollect ? <Entrance
              clusterId={id}
              collectStatus={collectStatus}
              setCollectStatus={setCollectStatus}
              wrapperClassName={styles.favourBtn}
              iconClassName='fs-14'
              isLarge
              collectEventFn={() => {
                bigdataFn('98b8a86c-2c6b-4882-add2-82a39c824ff3', '详情-收藏', '点击了详情-收藏', { op_block: '开店区域-详情页', op_event: ``, });
              }}
              modelConfigId={modelConfigId}
            /> : <></>
          }
          {/* 分享 */}
          <Share
            modelConfigId={modelConfigId}
            id={detail.id}
            globalAliasItemVOs={globalAliasItemVOs}
            tenantInfo={tenantInfo}
            userId={userId}
          />
          {/* 导出商圈报告PDF */}
          {
            exportPermission
              ? <>
                {/* {
                  showDownloadBtn
                    ? <div className='c-006 pointer ml-8 ml-8 fs-14' onClick={methods.handleDownload}>查看报告</div> : <></>
                } */}
                {
                  showDownloadBtn
                    ? <Button
                      onClick={methods.handleDownload}
                      className='ml-8'
                    >
                    查看报告
                    </Button> : <></>
                }
                <Button
                  loading={isExporting}
                  onClick={methods.exportPDF}
                  disabled={pdfDataStatus?.exportStatus === 3}
                  // 当存在集客点录入按钮时，集客点为primary，其余为default
                  type={gatherClientPoint?.permissionConfig?.isPermission || createTaskPermission ? 'default' : 'primary'}
                  className='inline-block ml-8'
                >
                  {isExporting ? '正在' : ''}导出报告
                </Button>
              </>
              : <></>
          }
          {
            detail?.orderAndCase ? <div className='ml-8'>
              <Button
                onClick={methods.jumpToTarget}
              >
              案例及订单
              </Button>
            </div> : <></>
          }
          {/* {
            historyTaskPermission && <Tooltip title={`历史${expansionTaskAlias || '任务'}`}>
              <div
                onClick={() => {
                  setHistoryVisible(true);
                  bigdataFn('b472312e-ebed-4edb-8ae2-56d3164876dc', '详情-任务历史', '点击了详情-任务历史', { op_block: '开店区域-详情页', op_event: `${detail?.cityName}-${detail.areaName}`, });
                }}
                className={cs(styles.historyBtn, 'ml-8')}>
                <IconFont iconHref='iconic_lishirenwu' className={styles.icon} />
              </div>
            </Tooltip>
          } */}
          {
            historyTaskPermission &&
              <div
                className='ml-8'>
                <Button
                  onClick={() => {
                    setHistoryVisible(true);
                    bigdataFn('b472312e-ebed-4edb-8ae2-56d3164876dc', '详情-任务历史', '点击了详情-任务历史', { op_block: '开店区域-详情页', op_event: `${detail?.cityName}-${detail.areaName}`, });
                  }}
                >
                  {`历史${expansionTaskAlias || '任务'}`}
                </Button>
              </div>
          }
          {
            createTaskPermission && <CreateTask
              id={id}
              needApproval={detail?.needTaskApproval}
              expansionTaskAlias={expansionTaskAlias}
              btnTitle={disabledCreateTask ? `${expansionTaskAlias || '任务'}进行中` : `发起${expansionTaskAlias || '拓店'}`}
              btnConfig={{
                disabled: disabledCreateTask,
                // 当配置了集客点时，让拓店任务按钮设为默认颜色
                type: gatherClientPoint?.permissionConfig?.isPermission ? 'default' : 'primary',
              }}
              className = 'ml-8'
              setShowCreateDrawer={setShowCreateDrawer}
              onCreateSuccess={getDetail}
            />
          }
          {/* 集客点按钮展示权限与状态 */}
          {
            gatherClientPoint?.permissionConfig?.isPermission ? <Button
              disabled={gatherClientPoint?.disabled}
              type='primary'
              onClick={() => {
                setGatherClientPointDrawer({
                  visible: true,
                  value: detail
                });
              }}
              className='inline-block ml-8'
            >
              {gatherClientPoint?.permissionConfig?.text}
            </Button> : <></>
          }
          {/* 编辑商圈权限及按钮 */}
          {
            editPermission ? <Button
              type='primary'
              onClick={() => {
                setEditModalData({
                  open: true,
                  // 优先取编辑后的回显
                  data: editModalData?.data || {},
                });
              }}
              className='inline-block ml-8'
            >
              {editPermission?.name}
            </Button> : <></>
          }
        </div>
      </div>
      {/* 标签行 */}
      <LabelRow
        id={id}
        overViewData={overViewData}
        onLabelChanged={onLabelChanged}
        labelOptionsChanged={labelOptionsChanged}
      />
      {/* 数据说明弹窗 */}
      <DataInfoModal
        open={openDataInfo}
        setOpen={setOpenDataInfo}
        markType={overViewData?.markType}
      />
      {/* 集客点录入弹窗 */}
      {gatherClientPoint?.permissionConfig?.isPermission
        ? <GatherClientDrawer
          open={gatherClientPointDrawer}
          setOpen={setGatherClientPointDrawer}
          onRefresh={onRefreshGather}
        />
        : <></>}
      <EditFormModal
        id={id}
        areaAlias={areaAlias}
        modalData={editModalData}
        setModalData={setEditModalData}
      />
    </div>
  );
};

export default Top;
